import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setThemeColor } from "../redux/action";

/**
 * Custom hook to access and update the dynamic theme color
 * @returns {Object} { themeColor, updateThemeColor }
 */
export const useThemeColor = () => {
  const dispatch = useDispatch();
  const {themeColor} = useSelector((state) => state.auth);

  // console.log("themeColor >> ", themeColor);

  // Apply theme color to CSS variables
  useEffect(() => {
    if (themeColor) {
      document.documentElement.style.setProperty('--theme-color', themeColor);
    }
  }, [themeColor]);

  const updateThemeColor = (color) => {
    // console.log("updateThemeColor >> ", color);
    dispatch(setThemeColor(color));
  };

  return {
    themeColor,
    updateThemeColor,
  };
};

